/**
 * Subscription Package Data
 * ข้อมูลแพ็กเกจ Subscription Plan สำหรับแต่ละ role
 */

export const subscriptionPackages = {
  customer: [
    {
      key: 'free',
      name: 'Free',
      price: 0,
      duration: 30, // วัน
      features: {
        maxImages: 0,
        dailyViews: 3,
        monthlyBookings: 1,
        revenueShare: 0,
        priority: false,
        analytics: false,
        support: 'Basic'
      },
      description: 'แผนเริ่มต้นสำหรับลูกค้าใหม่',
      popular: false,
      isActive: true
    },
    {
      key: 'basic',
      name: 'Basic',
      price: 100,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 10,
        monthlyBookings: 5,
        revenueShare: 0,
        priority: false,
        analytics: true,
        support: 'Email'
      },
      description: 'แผนพื้นฐานสำหรับลูกค้าทั่วไป',
      popular: true,
      isActive: true
    },
    {
      key: 'silver',
      name: 'Silver',
      price: 250,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 25,
        monthlyBookings: 15,
        revenueShare: 0,
        priority: true,
        analytics: true,
        support: 'Priority'
      },
      description: 'แผนเงินสำหรับลูกค้าประจำ',
      popular: false,
      isActive: true
    },
    {
      key: 'gold',
      name: 'Gold',
      price: 500,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 50,
        monthlyBookings: 30,
        revenueShare: 0,
        priority: true,
        analytics: true,
        support: 'VIP'
      },
      description: 'แผนทองสำหรับลูกค้าพรีเมียม',
      popular: false,
      isActive: true
    },
    {
      key: 'platinum',
      name: 'Platinum',
      price: 1000,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 100,
        monthlyBookings: 50,
        revenueShare: 0,
        priority: true,
        analytics: true,
        support: 'VIP'
      },
      description: 'แผนสูงสุดสำหรับลูกค้า VIP',
      popular: false,
      isActive: true
    }
  ],
  girl: [
    {
      key: 'free',
      name: 'Free',
      price: 0,
      duration: 30,
      features: {
        maxImages: 1,
        dailyViews: 0,
        monthlyBookings: 5,
        revenueShare: 0.3,
        priority: false,
        analytics: false,
        support: 'Basic'
      },
      description: 'แผนเริ่มต้นสำหรับน้องใหม่',
      popular: false,
      isActive: true
    },
    {
      key: 'basic',
      name: 'Basic',
      price: 100,
      duration: 30,
      features: {
        maxImages: 3,
        dailyViews: 0,
        monthlyBookings: 15,
        revenueShare: 0.35,
        priority: false,
        analytics: true,
        support: 'Email'
      },
      description: 'แผนพื้นฐานสำหรับน้องทั่วไป',
      popular: true,
      isActive: true
    },
    {
      key: 'premium',
      name: 'Premium',
      price: 300,
      duration: 30,
      features: {
        maxImages: 6,
        dailyViews: 0,
        monthlyBookings: 30,
        revenueShare: 0.4,
        priority: true,
        analytics: true,
        support: 'Priority'
      },
      description: 'แผนพรีเมียมสำหรับน้องคุณภาพ',
      popular: false,
      isActive: true
    },
    {
      key: 'vip',
      name: 'VIP',
      price: 500,
      duration: 30,
      features: {
        maxImages: -1, // ไม่จำกัด
        dailyViews: 0,
        monthlyBookings: 50,
        revenueShare: 0.5,
        priority: true,
        analytics: true,
        support: 'VIP'
      },
      description: 'แผน VIP สำหรับน้องระดับสูง',
      popular: false,
      isActive: true
    }
  ],
  momo: [
    {
      key: 'starter',
      name: 'Starter',
      price: 200,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 0,
        monthlyBookings: 10,
        revenueShare: 0.1,
        priority: false,
        analytics: false,
        support: 'Basic',
        teamSize: 1
      },
      description: 'แผนเริ่มต้นสำหรับโมใหม่',
      popular: false,
      isActive: true
    },
    {
      key: 'basic',
      name: 'Basic',
      price: 500,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 0,
        monthlyBookings: 25,
        revenueShare: 0.15,
        priority: false,
        analytics: true,
        support: 'Email',
        teamSize: 3
      },
      description: 'แผนพื้นฐานสำหรับโมทั่วไป',
      popular: true,
      isActive: true
    },
    {
      key: 'pro',
      name: 'Pro',
      price: 1000,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 0,
        monthlyBookings: 50,
        revenueShare: 0.2,
        priority: true,
        analytics: true,
        support: 'Priority',
        teamSize: 10
      },
      description: 'แผนโปรสำหรับโมมืออาชีพ',
      popular: false,
      isActive: true
    },
    {
      key: 'enterprise',
      name: 'Enterprise',
      price: 2000,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 0,
        monthlyBookings: 100,
        revenueShare: 0.25,
        priority: true,
        analytics: true,
        support: 'VIP',
        teamSize: 25
      },
      description: 'แผนองค์กรสำหรับโมขนาดใหญ่',
      popular: false,
      isActive: true
    },
    {
      key: 'ultraEnterprise',
      name: 'Ultra Enterprise',
      price: 5000,
      duration: 30,
      features: {
        maxImages: 0,
        dailyViews: 0,
        monthlyBookings: 200,
        revenueShare: 0.3,
        priority: true,
        analytics: true,
        support: 'VIP',
        teamSize: 50
      },
      description: 'แผนองค์กรขั้นสูงสำหรับโมระดับสูงสุด',
      popular: false,
      isActive: true
    }
  ]
};

/**
 * ดึงข้อมูลแพ็กเกจตาม role
 * @param {string} role - role ของผู้ใช้
 * @returns {Array} - รายการแพ็กเกจ
 */
export const getSubscriptionPackagesByRole = (role) => {
  return subscriptionPackages[role] || [];
};

/**
 * ดึงข้อมูลแพ็กเกจตาม key
 * @param {string} role - role ของผู้ใช้
 * @param {string} key - key ของแพ็กเกจ
 * @returns {object|null} - ข้อมูลแพ็กเกจหรือ null
 */
export const getSubscriptionPackageByKey = (role, key) => {
  const packages = getSubscriptionPackagesByRole(role);
  return packages.find(pkg => pkg.key === key) || null;
};

/**
 * ดึงแพ็กเกจที่สามารถอัพเกรดได้
 * @param {string} role - role ของผู้ใช้
 * @param {string} currentKey - key ของแพ็กเกจปัจจุบัน
 * @returns {Array} - รายการแพ็กเกจที่สูงกว่า
 */
export const getUpgradeablePackages = (role, currentKey) => {
  const packages = getSubscriptionPackagesByRole(role);
  const currentPackage = getSubscriptionPackageByKey(role, currentKey);
  
  if (!currentPackage) return packages;
  
  // หาแพ็กเกจที่ราคาสูงกว่า
  return packages.filter(pkg => pkg.price > currentPackage.price);
};

/**
 * ดึงแพ็กเกจยอดนิยม
 * @param {string} role - role ของผู้ใช้
 * @returns {object|null} - แพ็กเกจยอดนิยมหรือ null
 */
export const getPopularPackage = (role) => {
  const packages = getSubscriptionPackagesByRole(role);
  return packages.find(pkg => pkg.popular) || null;
};

/**
 * คำนวณราคาหลังหักส่วนลด
 * @param {number} basePrice - ราคาเดิม
 * @param {number} duration - ระยะเวลา (วัน)
 * @returns {number} - ราคาหลังหักส่วนลด
 */
export const calculateDiscountedPrice = (basePrice, duration) => {
  let discount = 0;
  
  if (duration >= 365) {
    discount = 20; // 1 ปี ลด 20%
  } else if (duration >= 90) {
    discount = 10; // 3 เดือน ลด 10%
  }
  
  return Math.round(basePrice * (1 - discount / 100));
};

/**
 * ดึงข้อมูลระยะเวลาและส่วนลด
 * @returns {Array} - รายการระยะเวลา
 */
export const getDurationOptions = () => [
  { days: 7, label: '1 สัปดาห์', discount: 0 },
  { days: 30, label: '1 เดือน', discount: 0 },
  { days: 90, label: '3 เดือน', discount: 10 },
  { days: 365, label: '1 ปี', discount: 20 }
];









